import { formatINRCompact } from "../../utils/formatCurrency";

// One chart look for the whole app (admin dashboard + Home page previews).
//
// Categorical slots, in fixed order, validated together on white:
// adjacent-pair colour-blind ΔE >= 9.1, normal-vision ΔE >= 22.9.
// Slots 3 and 4 sit below 3:1 contrast on white, so any chart that uses them
// must also show value labels (it can't rely on colour alone).
// Assign by entity, never by rank: a series keeps its slot whatever else is shown.
export const CHART_COLORS = {
  series1: "#2a78d6", // blue
  series2: "#eb6834", // orange
  series3: "#1baf7a", // aqua
  series4: "#eda100", // yellow
};

export const CATEGORICAL = [CHART_COLORS.series1, CHART_COLORS.series2, CHART_COLORS.series3, CHART_COLORS.series4];

export const CHART_TEXT = {
  primary: "#0f172a",
  secondary: "#475569",
  muted: "#64748b",
};

// Recessive axes and grid: values read off the marks, not the chrome.
export const chartSx = {
  "& .MuiChartsAxis-tickLabel": { fill: CHART_TEXT.muted, fontSize: 12 },
  "& .MuiChartsAxis-line, & .MuiChartsAxis-tick": { stroke: "#e2e8f0" },
  "& .MuiChartsGrid-line": { stroke: "#eef2f6" },
  "& .MuiChartsLegend-label": { color: "#334155", fontSize: 13 },
  "& .MuiLineElement-root": { strokeWidth: 2 },
  "& .MuiAreaElement-root": { fillOpacity: 0.12 },
  "& .MuiBarLabel-root": { fill: CHART_TEXT.primary, fontSize: 11, fontWeight: 600 },
};

// Rupee amounts in Indian compact units, e.g. "₹1.25 L".
export const formatRupees = (v: number | null | undefined) => (v == null ? "" : `₹${formatINRCompact(v)}`);

// Axis ticks: same units, trailing ".00" dropped so ticks stay short.
export const formatRupeesAxis = (v: number) => `₹${formatINRCompact(v).replace(/\.00(?= |$)/, "")}`;
